export enum PricingSurchargeSupplierOption {
  Inherit = 'inherit',
  Off = 'off',
}
